import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/gotoBroower.svg';
import _imports_1 from '@/assets/images/icons/copyAddress.svg';
import _imports_2 from '@/assets/images/stfil-logo.svg';
import _imports_3 from '@/assets/images/filecoin-logo.svg';
import _imports_4 from '@/assets/images/wstfil-logo.png';
import _imports_5 from '@/assets/images/icons/computer-greep.svg';
import _imports_6 from '@/assets/images/icons/link.svg';
const _withScopeId = n => (_pushScopeId("data-v-231fe097"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mt-4"
};
const _hoisted_2 = {
  class: "row justify-content-center"
};
const _hoisted_3 = {
  class: "col-xl-12 col-lg-12 text-white"
};
const _hoisted_4 = {
  class: "position-relative",
  style: {
    "background": "linear-gradient(52.01deg, rgb(40, 20, 74) 0%, rgb(81, 42, 150) 100%)",
    "margin-bottom": "-20px",
    "padding": "30px 0 25px 0",
    "border-top-left-radius": "1rem",
    "border-top-right-radius": "1rem"
  }
};
const _hoisted_5 = {
  class: "d-flex align-items-center pl-2"
};
const _hoisted_6 = {
  key: 0,
  class: "col-12 p-0 pl-4"
};
const _hoisted_7 = {
  class: "fw-medium fsi-14"
};
const _hoisted_8 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_9 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_10 = {
  key: 1,
  class: "col-12 p-0 pl-4"
};
const _hoisted_11 = {
  class: "fw-medium fsi-14"
};
const _hoisted_12 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_13 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-12 mt-2"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "1px",
    "width": "100%",
    "background-color": "#504a4a"
  }
})], -1));
const _hoisted_15 = {
  class: "d-flex mt-3 pl-2"
};
const _hoisted_16 = {
  key: 0,
  class: "col-12 p-0 pl-4"
};
const _hoisted_17 = {
  class: "d-flex align-items-center align-content-center"
};
const _hoisted_18 = {
  class: "fw-medium fsi-14",
  style: {
    "margin-right": "10px"
  }
};
const _hoisted_19 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_20 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_21 = {
  key: 1,
  class: "col-12 p-0 pl-4"
};
const _hoisted_22 = {
  class: "d-flex align-items-center align-content-center"
};
const _hoisted_23 = {
  class: "fw-medium fsi-14",
  style: {
    "margin-right": "10px"
  }
};
const _hoisted_24 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_25 = {
  class: "fw-extra-bold fsi-18"
};
const _hoisted_26 = {
  key: 0,
  class: "d-flex align-items-center mt-2"
};
const _hoisted_27 = {
  class: "col-12 p-0 pl-3"
};
const _hoisted_28 = {
  class: "pl-3 pt-1 pb-1 pr-2 mr-3",
  style: {
    "cursor": "pointer",
    "border-radius": "50px",
    "background-color": "rgba(0, 0, 0, 0.2)"
  }
};
const _hoisted_29 = {
  class: "fsi-14"
};
const _hoisted_30 = {
  class: "opacity-08 mr-1"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-hover",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_32 = [_hoisted_31];
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "transform": "translateY(-1px)"
  },
  class: "icon-hover",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_34 = [_hoisted_33];
const _hoisted_35 = {
  key: 1,
  class: "cursor-pointer fsi-14 ml-1",
  style: {
    "color": "#b8b8b8"
  }
};
const _hoisted_36 = {
  key: 1,
  class: "d-flex align-items-center mt-2"
};
const _hoisted_37 = {
  class: "col-12 p-0 pl-3"
};
const _hoisted_38 = {
  class: "pl-3 pt-1 pb-1 pr-2 mr-3",
  style: {
    "cursor": "pointer",
    "border-radius": "50px",
    "background-color": "rgba(0, 0, 0, 0.2)"
  }
};
const _hoisted_39 = {
  class: "fsi-14"
};
const _hoisted_40 = {
  class: "opacity-08 mr-1"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon-hover",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_42 = [_hoisted_41];
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "transform": "translateY(-1px)"
  },
  class: "icon-hover",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_44 = [_hoisted_43];
const _hoisted_45 = {
  key: 1,
  class: "cursor-pointer fsi-14 ml-1",
  style: {
    "color": "#b8b8b8"
  }
};
const _hoisted_46 = {
  class: "row justify-content-center mt-2"
};
const _hoisted_47 = {
  class: "col-12"
};
const _hoisted_48 = {
  class: "rounded shadow pt-3 pl-4 pr-4 pb-4 bg-white border-radius-20",
  style: {
    "border-radius": "1rem !important"
  }
};
const _hoisted_49 = {
  class: "w-100 d-flex justify-content-end"
};
const _hoisted_50 = {
  class: "fs-12 flex-center"
};
const _hoisted_51 = {
  style: {
    "transform": "translateY(2px)"
  },
  class: "mr-1"
};
const _hoisted_52 = ["innerHTML"];
const _hoisted_53 = {
  class: "mr-2"
};
const _hoisted_54 = {
  class: "text-left fw-extra-bold fsi-16 mb-2"
};
const _hoisted_55 = {
  class: "row"
};
const _hoisted_56 = {
  class: "col-12 mb-1 mt-2"
};
const _hoisted_57 = {
  class: "form-group mb-30 mt-3"
};
const _hoisted_58 = {
  class: "position-relative"
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "left": "0",
    "z-index": "100",
    "width": "4rem"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1.8rem"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "width": "1.8rem"
  },
  alt: ""
})])], -1));
const _hoisted_60 = {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "right": "0",
    "width": "6rem"
  }
};
const _hoisted_61 = ["disabled"];
const _hoisted_62 = {
  key: 0,
  class: "position-absolute d-flex align-items-center",
  style: {
    "bottom": "-22px",
    "text-align": "center",
    "font-size": "12px",
    "left": "5px",
    "right": "0",
    "color": "#e33a3a"
  }
};
const _hoisted_63 = {
  style: {
    "transform": "translateY(1.5px)",
    "margin-right": "4px"
  }
};
const _hoisted_64 = {
  class: "form-group mb-30 mt-3"
};
const _hoisted_65 = {
  class: "position-relative"
};
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "left": "0",
    "z-index": "100",
    "width": "4rem"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1.8rem"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})])], -1));
const _hoisted_67 = {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "right": "0",
    "width": "6rem"
  }
};
const _hoisted_68 = ["disabled"];
const _hoisted_69 = {
  key: 0,
  class: "position-absolute d-flex align-items-center",
  style: {
    "bottom": "-22px",
    "text-align": "center",
    "font-size": "12px",
    "left": "5px",
    "right": "0",
    "color": "#e33a3a"
  }
};
const _hoisted_70 = {
  style: {
    "transform": "translateY(1.5px)",
    "margin-right": "4px"
  }
};
const _hoisted_71 = {
  class: "form-group mb-30 mt-3"
};
const _hoisted_72 = {
  class: "position-relative"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "left": "0",
    "z-index": "100",
    "width": "4rem"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "position-relative",
  style: {
    "width": "1.8rem"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {
    "width": "1.8rem"
  },
  alt: ""
})])], -1));
const _hoisted_74 = {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "right": "0",
    "width": "6rem"
  }
};
const _hoisted_75 = ["disabled"];
const _hoisted_76 = {
  key: 0,
  class: "position-absolute d-flex align-items-center",
  style: {
    "bottom": "-22px",
    "text-align": "center",
    "font-size": "12px",
    "left": "5px",
    "right": "0",
    "color": "#e33a3a"
  }
};
const _hoisted_77 = {
  style: {
    "transform": "translateY(1.5px)",
    "margin-right": "4px"
  }
};
const _hoisted_78 = {
  class: "form-group mb-30 mt-3"
};
const _hoisted_79 = {
  class: "position-relative"
};
const _hoisted_80 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "left": "0",
    "z-index": "100",
    "width": "4rem"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "1.8rem"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {
    "width": "1.8rem"
  },
  alt: ""
})])], -1));
const _hoisted_81 = {
  class: "position-absolute d-flex justify-content-center align-items-center h-100",
  style: {
    "right": "0",
    "width": "6rem"
  }
};
const _hoisted_82 = ["disabled"];
const _hoisted_83 = {
  key: 0,
  class: "position-absolute d-flex align-items-center",
  style: {
    "bottom": "-22px",
    "text-align": "center",
    "font-size": "12px",
    "left": "5px",
    "right": "0",
    "color": "#e33a3a"
  }
};
const _hoisted_84 = {
  style: {
    "transform": "translateY(1.5px)",
    "margin-right": "4px"
  }
};
const _hoisted_85 = {
  class: "text-black-600"
};
const _hoisted_86 = {
  key: 0,
  class: "row mb-3"
};
const _hoisted_87 = {
  class: "mr-1"
};
const _hoisted_88 = {
  class: "mr-1"
};
const _hoisted_89 = {
  key: 1,
  class: "row mb-3"
};
const _hoisted_90 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_91 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_92 = {
  class: "d-flex justify-content-end w-100 align-items-center"
};
const _hoisted_93 = {
  class: "mr-1"
};
const _hoisted_94 = {
  class: "row"
};
const _hoisted_95 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_96 = {
  key: 0,
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_97 = {
  class: "d-flex justify-content-end w-100 align-items-center"
};
const _hoisted_98 = {
  class: "mr-1"
};
const _hoisted_99 = {
  key: 1,
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_100 = {
  class: "mr-1"
};
const _hoisted_101 = {
  key: 0,
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_102 = {
  class: "d-flex justify-content-end w-100 align-items-center"
};
const _hoisted_103 = {
  class: "mr-1"
};
const _hoisted_104 = {
  key: 1,
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_105 = {
  class: "mr-1"
};
const _hoisted_106 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_107 = {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
};
const _hoisted_108 = {
  class: "d-flex justify-content-end w-100 align-items-center"
};
const _hoisted_109 = {
  class: "mr-1"
};
const _hoisted_110 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cursor-pointer computer-css",
  src: _imports_5,
  style: {
    "width": "18px",
    "transform": "scale(1.3)"
  },
  alt: ""
}, null, -1));
const _hoisted_111 = {
  key: 1,
  class: "row mt-3"
};
const _hoisted_112 = {
  class: "col-6 text-left fw-medium fsi-14"
};
const _hoisted_113 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-6 text-right fw-medium fsi-14 opacity-08"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "mr-1"
}, " 1 stFIL = 1 FIL ")], -1));
const _hoisted_114 = {
  key: 0,
  class: "mt-4"
};
const _hoisted_115 = ["loading"];
const _hoisted_116 = {
  key: 1,
  class: "d-flex align-items-center"
};
const _hoisted_117 = {
  key: 0,
  class: "ml-2 cursor-pointer icon-hover"
};
const _hoisted_118 = {
  key: 1,
  class: "mt-4"
};
const _hoisted_119 = ["loading"];
const _hoisted_120 = {
  key: 1,
  class: "d-flex align-items-center"
};
const _hoisted_121 = {
  key: 0,
  class: "ml-2 cursor-pointer icon-hover"
};
const _hoisted_122 = {
  key: 0,
  class: "mt-4"
};
const _hoisted_123 = {
  key: 1,
  class: "d-flex align-items-center"
};
const _hoisted_124 = {
  key: 0,
  class: "ml-2 cursor-pointer icon-hover"
};
const _hoisted_125 = {
  key: 1,
  class: "mt-4"
};
const _hoisted_126 = {
  key: 1,
  class: "d-flex align-items-center"
};
const _hoisted_127 = {
  key: 0,
  class: "ml-2 cursor-pointer icon-hover"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_ScrollNumber = _resolveComponent("ScrollNumber");
  const _component_i_skeleton = _resolveComponent("i-skeleton");
  const _component_Tooltip = _resolveComponent("Tooltip");
  const _component_el_switch = _resolveComponent("el-switch");
  const _component_RadioBtn = _resolveComponent("RadioBtn");
  const _component_WarningFilled = _resolveComponent("WarningFilled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [$data.panelType === 'staking' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, "FIL " + _toDisplayString(_ctx.$t('common.Balance')), 1), _createVNode(_component_i_skeleton, {
    loading: _ctx.publicInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_skeleton_item, {
      variant: "h2",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_ScrollNumber, {
      color: "#fff",
      unit: "FIL",
      number: $options.formatWalletFilPrice(_ctx.filBalance, 6, false, true, false),
      h: 18
    }, null, 8, ["number"])])]),
    _: 1
  }, 8, ["loading"])])) : _createCommentVNode("", true), $data.panelType === 'wrap' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createTextVNode("stFIL " + _toDisplayString(_ctx.$t('common.Balance')) + " ", 1), $data.metaMaskInstall ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = (...args) => $options.addSTFIL && $options.addSTFIL(...args)),
    class: "fw-medium icon-hover",
    style: {
      "cursor": "pointer",
      "font-size": "12px",
      "margin-left": "2px",
      "color": "rgb(167 158 238)",
      "display": "inline-block",
      "transform": "scale(0.9)"
    }
  }, _toDisplayString(_ctx.$t('stake.AddSTFILToMetaMask')), 1)) : _createCommentVNode("", true)]), _createVNode(_component_i_skeleton, {
    loading: _ctx.publicInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_skeleton_item, {
      variant: "h2",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createVNode(_component_ScrollNumber, {
      color: "#fff",
      unit: "stFIL",
      number: $options.formatWalletFilPrice(_ctx.stFilBalance, 6, false, false, false),
      h: 18
    }, null, 8, ["number"])])]),
    _: 1
  }, 8, ["loading"])])) : _createCommentVNode("", true)]), _hoisted_14, _createElementVNode("div", _hoisted_15, [$data.panelType === 'staking' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createTextVNode("stFIL " + _toDisplayString(_ctx.$t('common.Balance')) + " ", 1), $data.metaMaskInstall ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    onClick: _cache[1] || (_cache[1] = (...args) => $options.addSTFIL && $options.addSTFIL(...args)),
    class: "fw-medium icon-hover",
    style: {
      "cursor": "pointer",
      "font-size": "12px",
      "margin-left": "2px",
      "color": "rgb(167 158 238)",
      "display": "inline-block",
      "transform": "scale(0.9)"
    }
  }, _toDisplayString(_ctx.$t('stake.AddSTFILToMetaMask')), 1)) : _createCommentVNode("", true)])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.publicInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_skeleton_item, {
      variant: "h2",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_ScrollNumber, {
      style: {
        "height": "30px",
        "line-height": "30px"
      },
      color: "#fff",
      unit: "stFIL",
      number: $options.formatWalletFilPrice(_ctx.stFilBalance, 6, false, false, false),
      h: 18
    }, null, 8, ["number"])])]),
    _: 1
  }, 8, ["loading"])])) : _createCommentVNode("", true), $data.panelType === 'wrap' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createTextVNode("wstFIL " + _toDisplayString(_ctx.$t('common.Balance')) + " ", 1), $data.metaMaskInstall ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    onClick: _cache[2] || (_cache[2] = (...args) => $options.addWSTFIL && $options.addWSTFIL(...args)),
    class: "fw-medium icon-hover",
    style: {
      "cursor": "pointer",
      "font-size": "12px",
      "margin-left": "2px",
      "color": "rgb(167 158 238)",
      "display": "inline-block",
      "transform": "scale(0.9)"
    }
  }, _toDisplayString(_ctx.$t('stake.AddSTFILToMetaMask')), 1)) : _createCommentVNode("", true)])]), _createVNode(_component_i_skeleton, {
    loading: _ctx.publicInfoLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_skeleton_item, {
      variant: "h2",
      style: {
        "width": "50%",
        "opacity": ".3"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_ScrollNumber, {
      style: {
        "height": "30px",
        "line-height": "30px"
      },
      color: "#fff",
      unit: "wstFIL",
      number: $options.formatWalletFilPrice(_ctx.wstFilBalance, 6, false, false, false),
      h: 18
    }, null, 8, ["number"])])]),
    _: 1
  }, 8, ["loading"])])) : _createCommentVNode("", true)]), $data.panelType === 'staking' ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("span", _hoisted_29, [_createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t('common.Contract')) + ":", 1), _createElementVNode("span", {
    onClick: _cache[3] || (_cache[3] = (...args) => $options.openAvailableliquidity && $options.openAvailableliquidity(...args)),
    class: "wfil-address-text icon-hover fs-12"
  }, _toDisplayString(_ctx.simpleContractAddress), 1), _createElementVNode("span", {
    class: "ml-2",
    onClick: _cache[4] || (_cache[4] = (...args) => $options.openAvailableliquidity && $options.openAvailableliquidity(...args))
  }, _hoisted_32), !$data.isCopy ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    style: {
      "opacity": ".8"
    },
    class: "ml-2 cursor-pointer copy-text",
    onClick: _cache[5] || (_cache[5] = (...args) => $options.copyAddress && $options.copyAddress(...args))
  }, _hoisted_34)) : _createCommentVNode("", true), $data.isCopy ? (_openBlock(), _createElementBlock("span", _hoisted_35, " copied ")) : _createCommentVNode("", true)])])])])) : _createCommentVNode("", true), $data.panelType === 'wrap' ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", _hoisted_39, [_createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('common.Contract')) + ":", 1), _createElementVNode("span", {
    onClick: _cache[6] || (_cache[6] = (...args) => $options.openAvailableliquidity && $options.openAvailableliquidity(...args)),
    class: "wfil-address-text icon-hover fs-12"
  }, _toDisplayString(_ctx.simpleWstFILContractAddress), 1), _createElementVNode("span", {
    class: "ml-2",
    onClick: _cache[7] || (_cache[7] = (...args) => $options.openAvailableliquidity && $options.openAvailableliquidity(...args))
  }, _hoisted_42), !$data.isCopy ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    style: {
      "opacity": ".8"
    },
    class: "ml-2 cursor-pointer copy-text",
    onClick: _cache[8] || (_cache[8] = (...args) => $options.copyAddress && $options.copyAddress(...args))
  }, _hoisted_44)) : _createCommentVNode("", true), $data.isCopy ? (_openBlock(), _createElementBlock("span", _hoisted_45, " copied ")) : _createCommentVNode("", true)])])])])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_46, [_createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_createVNode(_component_Tooltip, null, {
    default: _withCtx(() => [_createElementVNode("span", {
      innerHTML: _ctx.$t('common.what is wstfil')
    }, null, 8, _hoisted_52)]),
    _: 1
  })]), _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.$t('stake.Zap stFIL to wstFIL')), 1), _createVNode(_component_el_switch, {
    size: "small",
    disabled: $data.loading,
    style: {
      "--el-switch-on-color": "#6752F0"
    },
    modelValue: $data.isWrap,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.isWrap = $event)
  }, null, 8, ["disabled", "modelValue"])])]), _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('stake.WhichActionWouldYouLikeToChoose')), 1), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [$data.panelType === 'staking' ? (_openBlock(), _createBlock(_component_RadioBtn, {
    key: 0,
    "tab-arr": $data.radioOptions,
    modelValue: $data.stakeRadio,
    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.stakeRadio = $event)
  }, null, 8, ["tab-arr", "modelValue"])) : _createCommentVNode("", true), $data.panelType === 'wrap' ? (_openBlock(), _createBlock(_component_RadioBtn, {
    key: 1,
    "tab-arr": $data.wrapRadioOptions,
    modelValue: $data.wrapRadio,
    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.wrapRadio = $event)
  }, null, 8, ["tab-arr", "modelValue"])) : _createCommentVNode("", true)])]), $data.panelType === 'staking' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_withDirectives(_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_hoisted_59, _createElementVNode("div", _hoisted_60, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-info btn-sm btn-max",
    style: {
      "padding": "4px 15px"
    },
    onClick: _cache[12] || (_cache[12] = (...args) => $options.max && $options.max(...args))
  }, _toDisplayString(_ctx.$t("max")), 1)]), _withDirectives(_createElementVNode("input", {
    class: _normalizeClass(["form-control shadow-none stake-input", $data.unStakeInputIsErr ? 'stake-input-err' : '']),
    disabled: $data.loading,
    onInput: _cache[13] || (_cache[13] = (...args) => $options.stfilReceive && $options.stfilReceive(...args)),
    "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.data.stfil.receive = $event),
    type: "number",
    placeholder: "0.00",
    autocomplete: "off",
    id: "fname2",
    required: ""
  }, null, 42, _hoisted_61), [[_vModelText, $data.data.stfil.receive]]), $data.unStakeInputIsErr ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_createElementVNode("div", _hoisted_63, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_WarningFilled)]),
    _: 1
  })]), _createElementVNode("div", null, _toDisplayString($data.unStakeInputErr), 1)])) : _createCommentVNode("", true)])], 512), [[_vShow, $data.stakeRadio === 'UNSTAKE']]), _withDirectives(_createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_hoisted_66, _createElementVNode("div", _hoisted_67, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-info btn-sm btn-max",
    style: {
      "padding": "4px 15px"
    },
    onClick: _cache[15] || (_cache[15] = (...args) => $options.max && $options.max(...args))
  }, _toDisplayString(_ctx.$t("max")), 1)]), _withDirectives(_createElementVNode("input", {
    class: _normalizeClass(["form-control shadow-none stake-input", $data.stakeInputIsErr ? 'stake-input-err' : '']),
    disabled: $data.loading,
    onInput: _cache[16] || (_cache[16] = (...args) => $options.filReceive && $options.filReceive(...args)),
    "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.data.fil.receive = $event),
    type: "number",
    placeholder: "0.00",
    autocomplete: "off",
    id: "fname",
    required: ""
  }, null, 42, _hoisted_68), [[_vModelText, $data.data.fil.receive]]), $data.stakeInputIsErr ? (_openBlock(), _createElementBlock("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_WarningFilled)]),
    _: 1
  })]), _createElementVNode("div", null, _toDisplayString($data.stakeInputErr), 1)])) : _createCommentVNode("", true)])], 512), [[_vShow, $data.stakeRadio === 'STAKE']])], 64)) : _createCommentVNode("", true), $data.panelType === 'wrap' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_withDirectives(_createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_hoisted_73, _createElementVNode("div", _hoisted_74, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-info btn-sm btn-max",
    style: {
      "padding": "4px 15px"
    },
    onClick: _cache[18] || (_cache[18] = (...args) => $options.maxWrap && $options.maxWrap(...args))
  }, _toDisplayString(_ctx.$t("max")), 1)]), _withDirectives(_createElementVNode("input", {
    class: _normalizeClass(["form-control shadow-none stake-input", $data.unwrapInputIsErr ? 'stake-input-err' : '']),
    disabled: $data.loading,
    onInput: _cache[19] || (_cache[19] = (...args) => $options.wstfilReceive && $options.wstfilReceive(...args)),
    "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $data.data.wstfil.receive = $event),
    type: "number",
    placeholder: "0.00",
    autocomplete: "off",
    id: "fname3",
    required: ""
  }, null, 42, _hoisted_75), [[_vModelText, $data.data.wstfil.receive]]), $data.unwrapInputIsErr ? (_openBlock(), _createElementBlock("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_WarningFilled)]),
    _: 1
  })]), _createElementVNode("div", null, _toDisplayString($data.unwrapInputErr), 1)])) : _createCommentVNode("", true)])], 512), [[_vShow, $data.wrapRadio === 'UNWRAP']]), _withDirectives(_createElementVNode("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_hoisted_80, _createElementVNode("div", _hoisted_81, [_createElementVNode("button", {
    type: "button",
    class: "btn btn-info btn-sm btn-max",
    style: {
      "padding": "4px 15px"
    },
    onClick: _cache[21] || (_cache[21] = (...args) => $options.maxWrap && $options.maxWrap(...args))
  }, _toDisplayString(_ctx.$t("max")), 1)]), _withDirectives(_createElementVNode("input", {
    class: _normalizeClass(["form-control shadow-none stake-input", $data.wrapInputIsErr ? 'stake-input-err' : '']),
    disabled: $data.loading,
    onInput: _cache[22] || (_cache[22] = (...args) => $options.stfilReceiveByWrap && $options.stfilReceiveByWrap(...args)),
    "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => $data.data.stfil.receive = $event),
    type: "number",
    placeholder: "0.00",
    autocomplete: "off",
    id: "fname4",
    required: ""
  }, null, 42, _hoisted_82), [[_vModelText, $data.data.stfil.receive]]), $data.wrapInputIsErr ? (_openBlock(), _createElementBlock("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_WarningFilled)]),
    _: 1
  })]), _createElementVNode("div", null, _toDisplayString($data.wrapInputErr), 1)])) : _createCommentVNode("", true)])], 512), [[_vShow, $data.wrapRadio === 'WRAP']])], 64)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_85, [$data.panelType === 'wrap' ? (_openBlock(), _createElementBlock("div", _hoisted_86, [_createElementVNode("div", {
    class: _normalizeClass([_ctx.$i18n.locale === 'en' ? 'col-5' : 'col-4', "text-left fw-medium fsi-14"])
  }, _toDisplayString(_ctx.$t("exchange-rate")), 3), $data.wrapRadio === 'WRAP' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass([_ctx.$i18n.locale === 'en' ? 'col-7' : 'col-8', "text-right fw-medium fsi-14 opacity-08"])
  }, [_createVNode(_component_i_skeleton, {
    loading: $data.perTokenLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_87, " 1 stFIL = " + _toDisplayString($options.formatWalletFilPrice2($data.stFILPerToken, 4, false, false, false, true)) + " wstFIL ", 1)]),
    _: 1
  }, 8, ["loading"])], 2)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass([_ctx.$i18n.locale === 'en' ? 'col-7' : 'col-8', "text-right fw-medium fsi-14 opacity-08"])
  }, [_createVNode(_component_i_skeleton, {
    loading: $data.perTokenLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_88, " 1 wstFIL = " + _toDisplayString($options.formatWalletFilPrice2($data.wstFILPerToken, 4, false, false, false, true)) + " stFIL ", 1)]),
    _: 1
  }, 8, ["loading"])], 2))])) : _createCommentVNode("", true), $data.panelType === 'wrap' && $data.wrapRadio === 'WRAP' ? (_openBlock(), _createElementBlock("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.$t("common.Allowance")), 1), _createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, [_createVNode(_component_i_skeleton, {
    loading: $data.approveValueLoading
  }, {
    template: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
      style: {
        "width": "70%"
      }
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_93, _toDisplayString($options.formatWalletFilPrice2($data.approveValue.toBigInt(), 4, false, false, false, true)) + " stFIL ", 1)]),
    _: 1
  }, 8, ["loading"])])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_94, [_createElementVNode("div", _hoisted_95, _toDisplayString(_ctx.$t("you-will-receive")), 1), $data.panelType === 'staking' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$data.stakeRadio === 'STAKE' ? (_openBlock(), _createElementBlock("div", _hoisted_96, [_createElementVNode("div", _hoisted_97, [_createElementVNode("div", _hoisted_98, _toDisplayString($data.data.fil.receive || 0) + " stFIL ", 1)])])) : _createCommentVNode("", true), $data.stakeRadio === 'UNSTAKE' ? (_openBlock(), _createElementBlock("div", _hoisted_99, [_createElementVNode("div", _hoisted_100, _toDisplayString($data.data.stfil.receive || 0) + " FIL ", 1)])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [$data.wrapRadio === 'WRAP' ? (_openBlock(), _createElementBlock("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [_createElementVNode("div", _hoisted_103, _toDisplayString($options.formatWalletFilPrice2(_ctx.wrapReceiveWstfil, 6, false, false, false, true) || 0) + " wstFIL ", 1)])])) : _createCommentVNode("", true), $data.wrapRadio === 'UNWRAP' ? (_openBlock(), _createElementBlock("div", _hoisted_104, [_createElementVNode("div", _hoisted_105, _toDisplayString($options.formatWalletFilPrice2(_ctx.unwrapReceivestfil, 6, false, false, false, true) || 0) + " stFIL ", 1)])) : _createCommentVNode("", true)], 64))]), $data.panelType === 'staking' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [$data.stakeRadio === 'STAKE' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "row mt-3 cursor-pointer",
    onClick: _cache[24] || (_cache[24] = (...args) => $options.showComputer && $options.showComputer(...args))
  }, [_createElementVNode("div", _hoisted_106, _toDisplayString(_ctx.$t("stake.Expected")), 1), _createElementVNode("div", _hoisted_107, [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createTextVNode(_toDisplayString(_ctx.computerFileResult || 0) + " FIL ", 1), _hoisted_110])])])])) : _createCommentVNode("", true), $data.stakeRadio === 'UNSTAKE' ? (_openBlock(), _createElementBlock("div", _hoisted_111, [_createElementVNode("div", _hoisted_112, _toDisplayString(_ctx.$t("exchange-rate")), 1), _hoisted_113])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), $data.panelType === 'staking' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [$data.stakeRadio === 'STAKE' ? (_openBlock(), _createElementBlock("div", _hoisted_114, [!_ctx.isConnected ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "btn btn-primary w-100 border-radius-20",
    loading: _ctx.assetsLoading,
    onClick: _cache[25] || (_cache[25] = (...args) => $options.connectWallet && $options.connectWallet(...args))
  }, _toDisplayString(_ctx.$t('connect-wallet')) + " " + _toDisplayString(_ctx.isConnecting ? ' (connecting...)' : ''), 9, _hoisted_115)) : _createCommentVNode("", true), _ctx.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_116, [_createVNode(_component_el_button, {
    disabled: $data.data.fil.receive <= 0 || $data.stakeInputIsErr,
    class: "btn btn-primary i-button w-100",
    loading: $data.loading || _ctx.assetsLoading,
    onClick: $options.stake
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnText !== '' ? $data.btnText : _ctx.$t('stake.Stake')), 1)]),
    _: 1
  }, 8, ["disabled", "loading", "onClick"]), $data.hash !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_117, [_createElementVNode("img", {
    onClick: _cache[26] || (_cache[26] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale)),
    style: {
      "width": "32px"
    },
    src: _imports_6,
    alt: ""
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.stakeRadio === 'UNSTAKE' ? (_openBlock(), _createElementBlock("div", _hoisted_118, [!_ctx.isConnected ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "btn btn-primary w-100 border-radius-20",
    loading: _ctx.assetsLoading,
    onClick: _cache[27] || (_cache[27] = (...args) => $options.connectWallet && $options.connectWallet(...args))
  }, _toDisplayString(_ctx.$t('connect-wallet')) + " " + _toDisplayString(_ctx.isConnecting ? ' (connecting...)' : ''), 9, _hoisted_119)) : _createCommentVNode("", true), _ctx.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_120, [_createVNode(_component_el_button, {
    disabled: $data.data.stfil.receive <= 0 || $data.unStakeInputIsErr,
    class: "btn btn-primary i-button w-100",
    loading: $data.loading || _ctx.assetsLoading,
    onClick: $options.unstake
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnText !== '' ? $data.btnText : _ctx.$t('stake.unStake')), 1)]),
    _: 1
  }, 8, ["disabled", "loading", "onClick"]), $data.hash !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_121, [_createElementVNode("img", {
    onClick: _cache[28] || (_cache[28] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale)),
    style: {
      "width": "32px"
    },
    src: _imports_6,
    alt: ""
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 4
  }, [$data.wrapRadio === 'WRAP' ? (_openBlock(), _createElementBlock("div", _hoisted_122, [!_ctx.isConnected ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "btn btn-primary w-100 border-radius-20",
    onClick: _cache[29] || (_cache[29] = (...args) => $options.connectWallet && $options.connectWallet(...args))
  }, _toDisplayString(_ctx.$t('connect-wallet')), 1)) : _createCommentVNode("", true), _ctx.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_123, [_createVNode(_component_el_button, {
    disabled: $data.data.stfil.receive <= 0 || $data.wrapInputIsErr,
    class: "btn btn-primary i-button w-100",
    loading: $data.loading,
    onClick: $options.wrap
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnText !== '' ? $data.btnText : 'WRAP'), 1)]),
    _: 1
  }, 8, ["disabled", "loading", "onClick"]), $data.hash !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_124, [_createElementVNode("img", {
    onClick: _cache[30] || (_cache[30] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale)),
    style: {
      "width": "32px"
    },
    src: _imports_6,
    alt: ""
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $data.wrapRadio === 'UNWRAP' ? (_openBlock(), _createElementBlock("div", _hoisted_125, [!_ctx.isConnected ? (_openBlock(), _createElementBlock("button", {
    key: 0,
    class: "btn btn-primary w-100 border-radius-20",
    onClick: _cache[31] || (_cache[31] = (...args) => $options.connectWallet && $options.connectWallet(...args))
  }, _toDisplayString(_ctx.$t('connect-wallet')), 1)) : _createCommentVNode("", true), _ctx.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_126, [_createVNode(_component_el_button, {
    disabled: $data.data.wstfil.receive <= 0 || $data.unwrapInputIsErr,
    class: "btn btn-primary i-button w-100",
    loading: $data.loading,
    onClick: $options.unwrap
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.btnText !== '' ? $data.btnText : 'UNWRAP'), 1)]),
    _: 1
  }, 8, ["disabled", "loading", "onClick"]), $data.hash !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_127, [_createElementVNode("img", {
    onClick: _cache[32] || (_cache[32] = $event => $options.gotoHash($data.hash, _ctx.$i18n.locale)),
    style: {
      "width": "32px"
    },
    src: _imports_6,
    alt: ""
  })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64))])])])])]);
}